export const API_URL = process.env.VUE_APP_BACKEND_API_URL;
// export const HEROKU_URL = "http://localhost:8081";
export const HEROKU_URL = process.env.VUE_APP_HEROKU_URL || "https://api-nautilus.herokuapp.com";
export const URL_REGEX = new RegExp(
  "^(http(s?):\\/\\/)?" + // protocol
  "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
  "((\\d{1,3}\\.){3}\\d{1,3}))|" + // OR ip (v4) address
  "(localhost)" + // OR localhost
  "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
  "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    "(\\#[-a-z\\d_]*)?$",
  "i"
);

export const MOCK_URL = "https://private-33539d-naucomtool.apiary-mock.com";
